import React from 'react';
import { DateRangePicker, DateRangePickerShape } from 'react-dates';

const allowAll = () => false;

const MultiDatePicker = (props: DateRangePickerShape) => (
  <>
    <DateRangePicker
      displayFormat="DD-MMM-YY"
      showDefaultInputIcon={true}
      block={true}
      showClearDates={true}
      isOutsideRange={allowAll}
      {...props}
    />
  </>
);

export default MultiDatePicker;
